import { Row, Typography } from "antd"
import React, { FC } from "react"
import "./index.less"

const { Title } = Typography
const Header: FC<{ title: string }> = ({ title }) => {
  return (
    <Row className={"header"}>
      <Title level={1} className={"layout-main-title"}>
        {title}
      </Title>
    </Row>
  )
}

export default Header
